export const PARTNER_IDS = {
  EUROBONUS: "97BD026D-ADE1-4015-BE8A-2EF4672B155D",
} as const;
